module.exports = __webpack_public_path__ + "ac7648ea48e2e7c5a9fe20a464f2a727.svg";